import { render, staticRenderFns } from "./countries-select.vue?vue&type=template&id=283d6cd8&scoped=true&"
import script from "./countries-select.vue?vue&type=script&lang=js&"
export * from "./countries-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d6cd8",
  null
  
)

export default component.exports